<div class="nsc-form-field-toggle {{classGroup}}" >
  <div class="nsc-form-field-toggle__label" [class.nsc-form-field-toggle__label--disabled]="disabled">
    @if (label) {
      <mat-label id="{{idx}}-lbl" [attr.aria-disabled]="disabled">{{ label }}</mat-label>
    }
    @if (isHtmlContent) {
      <div  id="{{idx}}-lbl" innerHtml="{{isHtmlContent}}" [attr.aria-disabled]="disabled"></div>
    }
    <div class="mat-caption bold" [attr.aria-disabled]="disabled">{{ note }}</div>
  </div>
  <div class="nsc-form-field-toggle__actions d-flex align-items-center" [class.nsc-form-field-toggle__actions--disabled]="disabled">
    <mat-radio-group attr.aria-labelledby="{{idx}}-lbl" class="radio-group" id="{{ idx}}" [attr.aria-required]="required" [disabled]="disabled">
      <mat-radio-button class="nsc-radio-button" 
        id="{{idx}}_yes"
        name="{{controlName}}"
        value="YES"
        aria-label="Yes"
        [disableRipple]="true"        
        [checked]="group.controls[controlName].value === values.yes"
        (change)="changeValue(values.yes)"
        (click)="clickBtn(values.yes)">yes</mat-radio-button>
      <nsc-spacer horizontal="true"></nsc-spacer>
      <mat-radio-button class="nsc-radio-button" 
        id="{{idx}}_no"
        name="{{controlName}}"
        value="NO"
        aria-label="No"
        [disableRipple]="true"       
        [checked]="group.controls[controlName].value === values.no"
        (change)="changeValue(values.no)"
        (click)="clickBtn(values.no)">no</mat-radio-button>
    </mat-radio-group>
    @if (help) {
      <div class="nsc-form-field-toggle__help d-inline-block">
        <button type="button" [disabled]=disabled mat-icon-button [attr.aria-label]="(helpTitlePopUp ? helpTitlePopUp + ' Information' : 'Information')" (click)="openDialog()">
          <mat-icon aria-hidden="true">info</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
